import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainDbRoutingModule } from './main-db-routing.module';
import { MainDbComponent } from './main-db.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { HomePageComponent } from 'src/app/components/home-page/home-page.component';
import { RouterModule } from '@angular/router';
import { CustomersComponent } from 'src/app/components/customers/customers.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


@NgModule({
  declarations: [MainDbComponent, HomePageComponent, CustomersComponent],
  imports: [
    CommonModule,
    // MainDbRoutingModule,
    SharedModule,
    RouterModule,
    NgxDatatableModule
  ]
})
export class MainDbModule { }
